import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LicencesService } from '../licences.service';
import { GLOBAL } from 'src/app/app.globals';

@Component({
  selector: 'app-license-details',
  templateUrl: './license-details.component.html',
  styleUrls: ['./license-details.component.css']
})
export class LicenseDetailsComponent implements OnInit {
  @Input() licenseCode: string;
  @Input() requireType: number = 1; // 1: main Contractor | 0: Sub-Contractor
  @Output() closeModal = new EventEmitter<void>();

  licenseDetails: any = {};
  showGrid = true;

  // Column definitions for grids
  documentColDefs = [
    { headerName: 'Document Name', field: 'DocumentName', sortable: true, width: 150, cellStyle: { 'text-align': 'center' } },
    { headerName: 'Document Type', field: 'DocumentType', sortable: true, width: 120, cellStyle: { 'text-align': 'center' } },
    { headerName: 'Uploaded By', field: 'UploadedBy', sortable: true, width: 120, cellStyle: { 'text-align': 'center' } },
    { headerName: 'Size', field: 'size', sortable: true, width: 80, cellStyle: { 'text-align': 'center' } },
    { headerName: 'Uploaded Date', field: 'UploadedDate', sortable: true, width: 120, cellStyle: { 'text-align': 'center' },
      cellRenderer: (params) => params.value ? new Date(params.value).toLocaleDateString() : '-' },
    { headerName: 'Is Verify?', field: 'IsVerify', sortable: true, width: 90, cellStyle: { 'text-align': 'center' },
      cellRenderer: (params) => params.value ? 'Yes' : 'No' },
    { headerName: 'Verify Date', field: 'VerifyDate', sortable: true, width: 120, cellStyle: { 'text-align': 'center' },
      cellRenderer: (params) => params.value ? new Date(params.value).toLocaleDateString() : '-' },
    { headerName: 'Verify By', field: 'VerifyBy', sortable: true, width: 120, cellStyle: { 'text-align': 'center' } },
    { 
      headerName: 'View', 
      field: 'DocLink',
      sortable: false,
      width: 80,
      cellStyle: { 'text-align': 'center' },
      cellRenderer: (params) => {
        if (params.data && params.data.DocLink && params.data.DocumentName) {
          const fullPath = params.data.DocLink + params.data.DocumentName;
          return '<a href="' + GLOBAL.DOC_URL + '/' + fullPath + '" target="_blank"><i class="fa fa-eye" style="cursor: pointer; color: #4fc5ea;"></i></a>';
        }
        return '-';
      }
    }
  ];

  constructor(private licenceService: LicencesService, public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.licenseCode) {
      this.getLicenseDetails();
    }
  }

  getLicenseDetails(): void {
    const licenseCodeNum = parseInt(this.licenseCode, 10);
    this.licenceService.getLicenseDetailsNew(licenseCodeNum, this.requireType).subscribe((response: any) => {
      console.log('Full API Response:', response);
      if (response && response.Table1 && response.Table1.length > 0) {
        this.licenseDetails = response.Table1[0];
        this.licenseDetails.DocumentImageMasterViewModals = response.Table2 || [];
        console.log('License Details:', this.licenseDetails);
      }
    }, error => {
      console.error('Error fetching license details:', error);
    });
  }

  onCloseAction(): void {
    this.activeModal.close();
  }
}